<template>
    <div v-if="Object.keys(venueInfo).length" class="venue-profile-container">
        <div class="venue-profile-wrapper">
            <div id="preloader" v-show="load" class="preloader"></div>
            <div class="info-wrapper">
                <p class="venue-name">
                    {{ venueInfo.venue_name }}
                </p>
                <div class="venue-info">
                    <div class="venue-location">
                        <img :src="URLS.icons.location" alt="location-icon" />
                        <p>
                            {{ venueCityState(venueInfo.city_state_address) }}
                        </p>
                    </div>
                    <p class="venue-keywords">
                        {{ venueKeywords }}
                    </p>
                    <div class="venue-socials">
                        <div v-for="social in socialInfo" :key="social.link" class="social">
                            <a :href="socialLink(social)" target="_blank">
                                <img :src="URLS.icons[social.type]" :alt="social.type" />
                            </a>
                        </div>
                        <!-- @TODO: clean up once all providers are available and working
                            <div v-for="social in socialInfo" :key="social.link" class="social">
                                <a
                                    v-if="social.type !== 'Tiktok' || social.type !== 'Youtube'"
                                    :href="social.link"
                                    target="_blank"
                                >
                                    <img :src="URLS.icons[social.type]" :alt="social.type" />
                                </a>
                                <a
                                    v-if="social.type === 'Tiktok'"
                                    :href="'https://vm.tiktok.com/' + social.link"
                                    target="_blank"
                                >
                                    <img :src="URLS.icons[social.type]" :alt="social.type" />
                                </a>
                                <a
                                    v-if="social.type === 'Youtube'"
                                    :href="'https://www.youtube.com/channel/' + social.link"
                                    target="_blank"
                                >
                                    <img :src="URLS.icons[social.type]" :alt="social.type" />
                                </a>
                            </div>
                        -->
                    </div>
                </div>
                <div class="venue-bio">
                    <p v-if="!longBio" class="venue-description">
                        {{ venueInfo.description }}
                    </p>
                    <p v-else-if="longBio && !showBioPartTwo" class="venue-description">
                        {{ bioPartOne }}
                        <span v-if="!showBioPartTwo">...</span>
                    </p>
                    <button
                        v-if="longBio && !showBioPartTwo"
                        @click="handleReadMore"
                        class="read-more-btn"
                    >
                        Read More
                    </button>
                    <p v-else-if="longBio && showBioPartTwo" class="venue-description">
                        {{ venueInfo.description }}
                    </p>
                </div>
                <div v-if="currentUser" class="venue-actions">
                    <button @click="handleEditVenue" class="edit-page-btn">
                        Edit this page
                    </button>
                </div>
                <div v-else class="venue-actions">
                    <!-- @TODO add d-none until feature will be fixed -->
                    <button @click="handleShareAvails" class="share-avails-btn d-none">
                        Share Avails
                    </button>
                    <!--
                    <button
                        :disabled="followingVenue === 'Following' || !fetchedContacts"
                        @click="followBtnClick"
                        class="follow-venue-btn"
                    >
                        {{ followingVenue }}
                    </button>
                    -->
                </div>
                <div :style="backgroundImage" class="venue-profile-image"></div>
            </div>
            <div v-if="filteredOpenEvents.length" class="events-wrapper">
                <p class="title">Open Events</p>
                <div v-if="!screen.isMobile.value" class="event-cards-wrapper">
                    <event-cards
                        :eventsInfo="filteredOpenEvents"
                        :renderShortDate="true"
                        :profile="true"
                        :styles="openEventCardStyles"
                        @event-image-clicked="() => {}"
                        @event-date-clicked="() => {}"
                        @event-title-clicked="() => {}"
                    >
                        <template #date-extra="{ event }">
                            <p class="event-time">Doors at {{ eventTime(event) }}</p>
                            <p v-if="event.cover_cost" class="cover-charge">
                                {{ `$${coverCost(event.cover_cost)} Cover` }}
                            </p>
                            <p v-if="eventAgeVibe" class="event-age">
                                {{ eventAgeVibe(event) }}
                            </p>
                        </template>
                        <template #title-extra="{ event }">
                            <p class="title-extra">
                                at {{ event.venue.venue_info.venue_name }}
                            </p>
                        </template>
                        <template #info-extra="{ event }">
                            <div v-if="event.array_keywords.length" class="keyword-vibes">
                                <span class="vibe">Vibe: </span>
                                <span class="vibe">{{ eventVibes(event) }}</span>
                            </div>
                        </template>
                        <!-- <template #event-action> -->
                        <!--     <div class="event-action-btns"> -->
                        <!--         <button class="make-offer-btn">Make an Offer</button> -->
                        <!--         <button class="add-to-cal-btn">Add to calendar</button> -->
                        <!--         <button class="share-btn">Share</button> -->
                        <!--     </div> -->
                        <!-- </template> -->
                    </event-cards>
                </div>
                <div v-else class="event-card-wrapper">
                    <MobileEventCards
                        :eventsInfo="filteredOpenEvents"
                        :renderShortDate="true"
                        :profile="true"
                        :venue="true"
                    />
                </div>
            </div>
            <div v-if="filteredConfirmedEvents.length" class="events-wrapper">
                <p class="title">Upcoming Shows</p>
                <div
                    v-if="!screen.isMobile.value"
                    :style="confirmedEventsStyle"
                    class="event-cards-wrapper confirmed-events-wrapper"
                >
                    <event-cards
                        :eventsInfo="filteredConfirmedEvents"
                        :profile="true"
                        :renderShortDate="true"
                        :event-clickable="true"
                        :styles="eventCardStyles"
                        @event-image-clicked="() => {}"
                        @event-date-clicked="() => {}"
                        @event-title-clicked="() => {}"
                    >
                        <template #date-extra="{ event }">
                            <p class="event-time">Doors at {{ eventTime(event) }}</p>
                            <p class="cover-charge">
                                {{ `$${coverCost(event.cover_cost)} Cover` }}
                            </p>
                            <p v-if="eventAgeVibe(event)" class="event-age">
                                {{ eventAgeVibe(event) }}
                            </p>
                        </template>
                        <template #title-extra="{ event }">
                            <p class="title-extra">
                                at {{ event.venue.venue_info.venue_name }}
                            </p>
                        </template>
                        <template #info-extra="{ event }">
                            <div v-if="event.array_keywords.length" class="keyword-vibes">
                                <span class="vibe">Vibe: </span>
                                <span class="vibe">{{ eventVibes(event) }}</span>
                            </div>
                            <div class="featured-artists-wrapper">
                                <p
                                    v-if="
                                        event.respondedArtists && event.respondedArtists.length
                                    "
                                    class="featured-label"
                                >
                                    Featuring:
                                </p>
                                <div
                                    v-for="(user, indx) in event.respondedArtists"
                                    :key="indx"
                                    class="featured-artist"
                                >
                                    <img :src="user.avatar" alt="artist-avatar" />
                                    <p class="featured-artist-name">
                                        {{ user.artist.artist_info.band_name }}
                                    </p>
                                </div>
                            </div>
                        </template>
                        <!-- <template #event-action> -->
                        <!--     <div class="event-action-btns"> -->
                        <!--         <button class="add-to-cal-btn">Add to calendar</button> -->
                        <!--         <button class="share-btn">Share</button> -->
                        <!--     </div> -->
                        <!-- </template> -->
                    </event-cards>
                </div>
                <div v-else class="event-card-wrapper">
                    <MobileEventCards
                        :eventsInfo="filteredConfirmedEvents"
                        :renderShortDate="true"
                        :profile="true"
                        :venue="true"
                    />
                </div>
                <button
                    v-if="renderShowMoreBtn"
                    @click="handleShowMoreEvents"
                    class="more-events-btn"
                >
                    Show More Events
                </button>
                <div v-if="renderShowMoreBtn" class="overlay"></div>
            </div>
            <div v-if="mediaCarousel.length" class="media-wrapper">
                <p class="title">Media</p>
                <div :style="mediaCarouselStyle" class="media-carousel-wrapper">
                    <carousel
                        :mediaList="mediaCarousel"
                        :options="
                            screen.isMobile.value
                                ? carouselOptions.mobileStyle
                                : carouselOptions.style
                        "
                        @currentMediaIndx="updateCurrentMediaIndx"
                    >
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { api } from '@/helpers/api'
    import { notification } from '@/helpers/notification'
    import EventCards from '@/components/ui/cards/EventCards.vue'
    import MobileEventCards from '@/components/ui/cards/MobileEventCards.vue'
    import Carousel from '@/components/ui/carousels/Carousel.vue'
    import useCheckScreen from '@/composables/useCheckScreen.js'
    import { useAuth } from '@/composables/auth/useAuth'

    const URLS = {
        xhr: {
            fetch: {
                checkAuth: '/api/check-authorization',
                user: '/api/profile/v1/settings/user',
                media: '/api/profile/v1/user-profile/venue-medias',
                venue: '/api/profile/v1/user-profile/venue-info',
                social: '/api/profile/v1/user-profile/venue-social-links',
                facility: '/api/profile/v1/info/venue/facility-settings',
                openEvents: '/api/events/new-and-proceed-list-guest',
                confirmedEvents: '/api/events/confirmed-list-guest',
                artistContacts: '/api/profile/contacts/artist/list'
            },
            mutate: {
                addVenueContact: '/api/profile/contacts/user/venue'
            }
        },
        icons: {
            Instagram: '/images/icons/instagram-grey.svg',
            Facebook: '/images/icons/facebook-grey.svg',
            Tiktok: '/images/icons/tiktok-grey.svg',
            Youtube: '/images/icons/youtube-grey.svg',
            web_site: '/images/icons/web-grey.svg',
            location: '/images/icons/location.svg',
            play: '/images/icons/video-play.svg'
        },
        redirect: {
            edit: ['/venues', 'edit']
        }
    }
    export default {
        name: 'VenueProfile',
        components: {
            EventCards,
            MobileEventCards,
            Carousel
        },
        props: {
            venue: {
                required: true,
                type: Number,
                validator: (v) => v >= 0
            },
            upfluenceData: {
                type: String,
                required: true,
                validator(val) {
                    try {
                        return !!(JSON.parse(val) && val)
                    } catch (e) {
                        return false
                    }
                }
            }
        },
        data: () => ({
            authed: false,
            load: false,
            fetchedContacts: false,
            showMoreEvents: false,
            showBioPartTwo: false,
            userInfo: {},
            venueInfo: {},
            upfluenceInfo: {},
            socialInfo: [],
            mediaInfo: [],
            openEventsInfo: [],
            confirmedEventsInfo: [],
            filteredOpenEvents: [],
            filteredConfirmedEvents: [],
            contacts: [],
            mediaCarousel: [],
            openEventCardStyles: {
                card: {
                    'min-height': '160px'
                },
                date: {
                    color: '#acacac',
                    'font-size': '26px'
                },
                title: {
                    color: '#acacac',
                    'font-size': '20px',
                    'font-weight': '650'
                },
                image: {
                    width: '182px'
                }
            },
            eventCardStyles: {
                card: {
                    'min-height': '230px',
                    cursor: 'pointer'
                },
                date: {
                    color: '#acacac',
                    'font-size': '26px'
                },
                title: {
                    color: '#acacac',
                    'font-size': '20px',
                    'font-weight': '650'
                },
                image: {
                    width: '182px'
                }
            },
            carouselOptions: {
                index: 0,
                style: {
                    currentMedia: {
                        width: 406,
                        height: 406
                    },

                    otherMedia: {
                        width: 365,
                        height: 365
                    },

                    actionBtns: {
                        Xoffset: 280,
                        Yoffset: 235,
                        twoMediaXoffSet: 100
                    }
                },
                mobileStyle: {
                    currentMedia: {
                        width: 260,
                        height: 260
                    },
                    otherMedia: {
                        width: 220,
                        height: 220
                    },
                    actionBtns: {
                        Xoffset: 200,
                        Yoffset: 180,
                        twoMediaXoffSet: 100
                    }
                }
            }
        }),
        computed: {
            URLS: () => URLS,
            backgroundImage: (self) => {
                if (
                    self.venueInfo.avatar &&
                    !self.venueInfo.avatar.includes('/images/global/default.png')
                ) {
                    const avatar = encodeURI(self.venueInfo.avatar)
                    return {
                        'background-image': `linear-gradient(to left, transparent 50%, #121212 100%), linear-gradient(to bottom, transparent 50%, #121212 100%), url('${avatar}')`
                    }
                }

                return {}
            },
            socialReach: (self) =>
                self.formatSummedValue(self.upfluenceInfo.overall_stats.socialReach),
            venueCityState: () => (address) => {
                let addressArr = address.replace(', USA', '').split(',').reverse()
                let city = addressArr[1]
                let state = addressArr[0].trim().split(' ')[0]

                return `${city}, ${state}`
            },
            venueKeywords: (self) =>
                self.venueInfo.keyword ? self.venueInfo.keyword.split(',').join(', ') : '',
            longBio: (self) =>
                self.venueInfo.description && self.venueInfo.description.length > 370,
            bioPartOne: (self) =>
                self.venueInfo.description ? self.venueInfo.description.slice(0, 371) : '',
            bioPartTwo: (self) =>
                self.venueInfo.description ? self.venueInfo.description.slice(371) : '',
            currentUser: (self) => self.authed && self.userInfo.venueSlug === self.currentSlug,
            currentSlug: () => {
                let url = window.location.href

                if (url[url.length - 1] === '/') {
                    url = url.slice(0, -1)
                }
                return url.split('/').pop()
            },
            coverCost: () => (cost) => {
                if (cost) return cost
                return '0'
            },
            eventTime: () => (event) => {
                if (event.start_time) return event.start_time.split(' - ')[0]
                return 'N/A'
            },
            eventAgeVibe: () => (event) => {
                let vibes = event.array_keywords

                if (!vibes) return null

                if (vibes.some((v) => v.toLowerCase() === '21 and over')) {
                    return '21 and over'
                } else {
                    return 'All Ages'
                }
            },
            eventVibes: () => (event) => {
                if (event.array_keywords.length) {
                    return event.array_keywords.join(', ')
                }

                return ''
            },
            renderShowMoreBtn: (self) =>
                self.filteredConfirmedEvents.length >= 4 && !self.showMoreEvents,
            confirmedEventsStyle: (self) => {
                if (self.showMoreEvents) {
                    return {
                        'max-height': 'none',
                        overflow: 'inherit'
                    }
                }
            },
            mediaCarouselStyle: (self) => {
                if (!self.screen.isMobile.value && !self.screen.isSmallMobile.value) {
                    return self.regularScreenCarouselStyles
                } else if (self.screen.isMobile.value && !self.screen.isSmallMobile.value) {
                    return self.mobileScreenCarouselStyles
                } else if (self.screen.isSmallMobile.value) {
                    return self.xsScreenCarouselStyles
                }
            },
            regularScreenCarouselStyles: (self) => {
                if (self.mediaCarousel.length === 1) {
                    return {
                        'margin-left': '100px'
                    }
                } else if (self.mediaCarousel.length === 2) {
                    return {
                        'margin-left': '200px'
                    }
                } else {
                    return {
                        'margin-left': '140px'
                    }
                }
            },
            mobileScreenCarouselStyles: (self) => {
                if (self.mediaCarousel.length === 1) {
                    return {
                        'margin-left': 'auto',
                        'margin-right': 'auto'
                    }
                } else if (self.mediaCarousel.length === 2) {
                    return {
                        'margin-left': '200px'
                    }
                } else {
                    return {
                        'margin-left': '118px'
                    }
                }
            },
            xsScreenCarouselStyles: (self) => {
                if (self.mediaCarousel.length === 1) {
                    return {
                        'margin-left': 'auto',
                        'margin-right': 'auto'
                    }
                } else if (self.mediaCarousel.length === 2) {
                    return {
                        'margin-left': '200px'
                    }
                } else {
                    return {
                        'margin-left': '91px'
                    }
                }
            },
            socialLink: () => (social) => {
                switch (social.type) {
                    case 'web_site':
                        return social.link
                    case 'Instagram':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.instagram.com/${social.link}`
                    case 'Facebook':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.facebook.com/${social.link}`
                    case 'Tiktok':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://vm.tiktok.com/${social.link}`
                    case 'Youtube':
                        return social.link.includes(social.type.toLowerCase())
                            ? social.link
                            : `https://www.youtube.com/channel/${social.link}`
                    default:
                        return '#'
                }
            } /*,
            followingVenue: (self) =>
                self.contacts.some((c) => c.venue_id === self.venueInfo.venue_id)
                    ? 'Following'
                    : 'Follow'*/
        },
        watch: {
            venueInfo: function (info) {
                if (Object.keys(info).length) {
                    this.load = false
                }
            },
            mediaInfo: function (medias) {
                if (medias.length) {
                    this.filterMedia()
                }
            },
            confirmedEventsInfo: function (events) {
                if (events.length) {
                    this.filterEvents(events, 'filteredConfirmedEvents')
                }
            },
            openEventsInfo: function (events) {
                if (events.length) {
                    this.filterEvents(events, 'filteredOpenEvents')
                }
            }
        },
        setup() {
            const { handleShowRegisterModal } = useAuth()
            const { isSmallMobile, isMobile } = useCheckScreen()
            return {
                handleShowRegisterModal,
                screen: {
                    isSmallMobile,
                    isMobile
                }
            }
        },
        async created() {
            this.load = true

            await this.checkAuthorization()
            if (this.authed) {
                this.userInfo = await this.fetchUserInfo()
            }
            await this.initComponentData()
        },
        methods: {
            async initComponentData() {
                try {
                    this.load = true

                    const infoResp = await this.fetchVenueInfo()
                    this.venueInfo = infoResp.data

                    if (this.authed) {
                        const artistContactsResp = await this.fetchArtistContacts()
                        this.contacts = artistContactsResp.data
                    }
                    this.fetchedContacts = true

                    const socialResp = await this.fetchVenueSocial()
                    this.socialInfo = this.populateSocialData(socialResp.data)

                    const mediaResp = await this.fetchVenueMedia()
                    this.mediaInfo = mediaResp.data

                    const openEventResp = await this.fetchOpenEventsInfo()
                    this.openEventsInfo = openEventResp.bids

                    const confirmedEventResp = await this.fetchConfirmedEventsInfo()
                    this.confirmedEventsInfo = confirmedEventResp.bids

                    this.upfluenceInfo = JSON.parse(this.upfluenceData)

                    if (this.venueInfo.web_site) {
                        this.$set(this.socialInfo, this.socialInfo.length, {
                            type: 'web_site',
                            link: this.formatWebsite(this.venueInfo.web_site)
                        })
                    }
                } catch (e) {
                    console.error(e)
                } finally {
                    this.load = false
                }
            },
            async checkAuthorization() {
                try {
                    const data = await api({
                        method: 'get',
                        url: this.URLS.xhr.fetch.checkAuth
                    })
                    this.authed = data.isAuthorized
                } catch {
                    this.authed = false
                }
            },
            async fetchUserInfo() {
                try {
                    this.load = true
                    const data = await api({
                        method: 'get',
                        url: this.URLS.xhr.fetch.user
                    })

                    return data.data[0]
                } finally {
                    this.load = false
                }
            },
            async fetchVenueInfo() {
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.venue}/${this.venue}`
                })
            },
            async fetchVenueSocial() {
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.social}/${this.venue}`
                })
            },
            async fetchVenueMedia() {
                return await api({
                    method: 'get',
                    url: `${this.URLS.xhr.fetch.media}/${this.venue}`
                })
            },
            async fetchVenueFac() {
                return await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.facility
                })
            },
            async fetchOpenEventsInfo() {
                return await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.openEvents
                })
            },
            async fetchConfirmedEventsInfo() {
                return await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.confirmedEvents
                })
            },
            async fetchArtistContacts() {
                return await api({
                    method: 'get',
                    url: this.URLS.xhr.fetch.artistContacts
                })
            },
            updateCurrentMediaIndx(indx) {
                this.carouselOptions.index = indx
            },
            handleEditVenue() {
                this.redirectToEditVenue()
            },
            handleShareAvails() {},
            async handleFollowVenue() {
                const postData = {
                    venue_id: this.venueInfo.venue_id
                }
                try {
                    this.load = true
                    const data = await api({
                        method: 'post',
                        url: this.URLS.xhr.mutate.addVenueContact,
                        data: postData
                    })
                    this.contacts.push(postData)
                    notification('success', 'Added venue to your contact list.')
                    return data
                } finally {
                    this.load = false
                }
            },
            handleReadMore() {
                this.showBioPartTwo = true
            },
            handleShowMoreEvents() {
                this.showMoreEvents = true
            },
            populateSocialData(socials) {
                return socials.map((s) => ({
                    ...s,
                    link:
                        s.type === 'Youtube' || s.type === 'Tiktok'
                            ? s.link
                            : s.link.includes('http')
                            ? s.link
                            : 'https://' + s.link
                }))
            },
            filterEvents(events, ref) {
                let venueEvents = []

                for (let i = 0; i < events.length; i++) {
                    let event = events[i]

                    if (event.venue?.venue_info.slug === this.currentSlug) {
                        venueEvents.push(event)
                    }
                }

                this[ref] = venueEvents
            },
            filterMedia() {
                this.mediaCarousel = this.mediaInfo.filter((m) => m.type === 'image')
            },
            formatWebsite(url) {
                if (!url.includes('http')) {
                    return `http://${url}`
                }

                return url
            },
            formatSummedValue(num) {
                if (num >= 1_000_000_000) {
                    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
                }
                if (num >= 1_000_000) {
                    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
                }
                if (num >= 1_000) {
                    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
                }
                if (num <= 0 || !num) {
                    return 'N/A'
                }
                return num.toFixed(0).toString()
            },
            redirectToEditVenue() {
                window.location.href = `${this.URLS.redirect.edit[0]}/${this.venueInfo.slug}/${this.URLS.redirect.edit[1]}`
            },
            followBtnClick() {
                if (this.authed) {
                    this.handleFollowVenue()
                } else {
                    this.handleShowRegisterModal()
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    $smallMobile: 350px;
    $mobileMax: 600px;
    $tablet: 800px;
    @media screen and (max-width: $mobileMax) {
        .venue-profile-wrapper {
            padding-left: 16px !important;
            .venue-name {
                font-size: 44px !important;
                font-weight: 500 !important;
                line-height: 110% !important;
                letter-spacing: -1.76px !important;
                max-width: 280px !important;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .edit-page-btn,
            .share-avails-btn,
            .follow-venue-btn {
                width: 100%;
            }
            .media-wrapper {
                max-width: 343px;
                min-width: 270px;
                width: 100%;
                .media-carousel-wrapper {
                    margin-right: 0px;
                    width: auto;
                    transform: none;
                }
            }
        }
    }
    @media screen and (max-width: $tablet) {
        .media-wrapper {
            max-width: 690px;
            .media-carousel-wrapper {
                margin-right: 140px;
                width: 670px;
                transform: translateX(-45px);
            }
        }
    }
    .venue-profile-container {
        display: flex;
        flex-direction: row;
        justify-content: center;

        .venue-profile-wrapper {
            display: flex;
            flex-direction: column;
            position: relative;
            padding-left: 40px;
            align-items: flex-start;
            min-width: 300px;
            max-width: 1440px;
            width: 100%;
            gap: 80px;

            .events-wrapper,
            .media-wrapper {
                .title {
                    margin-bottom: 0px;
                    color: #acacac;
                    font-family: Instrument Sans;
                    font-size: 38px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 110%;
                    letter-spacing: -0.76px;
                }
            }
            .info-wrapper {
                display: flex;
                flex-direction: column;
                gap: 20px;
                margin-top: 270px;
                max-width: 600px;
                min-width: 280px;
                width: 100%;
                padding-right: 10px;

                .venue-name {
                    color: #ba87ff;
                    font-family: Instrument Sans;
                    font-size: 72px;
                    font-style: normal;
                    font-weight: 525;
                    line-height: 95%;
                    letter-spacing: -3.6px;
                    margin-bottom: 0px;
                    text-wrap: wrap;
                    max-width: 727px;
                    z-index: 1;
                }
                .venue-info {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    z-index: 1;
                    gap: 12px;

                    .venue-social-reach {
                        margin-bottom: 0px;
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 38px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 110%;
                        letter-spacing: -0.76px;
                    }

                    .venue-location {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        gap: 8px;

                        img {
                            width: 15px;
                            height: 15px;
                        }
                        p {
                            color: #acacac;
                            font-family: Instrument Sans;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 650;
                            line-height: 125%;
                            margin-bottom: 0px;
                        }
                    }

                    .venue-keywords::-webkit-scrollbar {
                        height: 4px;
                    }
                    .venue-keywords::-webkit-scrollbar-track {
                        background-color: none;
                    }
                    .venue-keywords::-webkit-scrollbar-thumb {
                        max-height: 64px;
                        border-radius: 8px;
                        background: #8b8b8b;
                    }
                    .venue-keywords {
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 125%;
                        margin-bottom: 0px;
                        text-wrap: nowrap;
                        overflow-x: scroll;
                        max-width: 500px;
                        min-width: 250px;
                        width: 100%;
                        padding-bottom: 7px;
                    }

                    .venue-socials {
                        display: flex;
                        gap: 20px;
                        img {
                            max-width: 95px;
                            min-width: 24px;
                            width: 100%;
                            max-height: 24px;
                            min-height: 24px;
                        }
                    }
                }

                .venue-bio {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    max-width: 600px;
                    min-height: 100px;
                    z-index: 1;

                    .venue-description {
                        white-space: pre-line;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-bottom: -10px !important;
                        max-width: 600px;
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        letter-spacing: -0.2px;
                        margin-bottom: 0px;
                        text-wrap: wrap;
                    }

                    .read-more-btn {
                        margin-top: 12px;
                        color: #acacac;
                        font-family: Instrument Sans;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 550;
                        line-height: 125%;
                        text-decoration-line: underline;
                        background: none;
                        border: none;
                        margin-right: auto;
                        padding-left: 0px;
                    }
                }

                .venue-profile-image {
                    position: absolute;
                    z-index: 0;
                    top: 0;
                    right: 0;
                    box-shadow: 0px 0px 200px #121212 inset;
                    width: 924px;
                    height: 902px;
                    background-repeat: no-repeat;
                    background-size: cover;
                }

                .venue-actions {
                    margin-top: 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    z-index: 1;
                    gap: 12px;

                    .share-avails-btn,
                    .edit-page-btn {
                        border: none;
                        padding: 11px 30px 12px 30px;
                        border-radius: 100px;
                        background: #ba87ff;
                        color: black;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        min-width: 173px;
                        text-wrap: nowrap;
                    }
                    .follow-venue-btn {
                        padding: 11px 30px 12px 30px;
                        border: 1px solid #ba87ff;
                        border-radius: 100px;
                        background: #121212;
                        color: #ba87ff;
                        font-family: Instrument Sans;
                        font-size: 18px;
                        font-style: normal;
                        font-weight: 650;
                        line-height: 120%;
                        min-width: 173px;
                    }
                }
            }

            .events-wrapper {
                display: flex;
                flex-direction: column;
                gap: 32px;
                z-index: 11;
                position: relative;
                max-width: 100%;

                .overlay {
                    background: linear-gradient(to bottom, transparent, black);
                    position: absolute;
                    width: 100%;
                    height: 88px;
                    bottom: 8%;
                    border-radius: 15px 15px 0px 0px;
                }

                .more-events-btn {
                    padding: 11px 30px 12px 30px;
                    min-width: 667px;
                    border-radius: 100px;
                    border: 1px solid #ba87ff;
                    background: #121212;
                    color: #ba87ff;
                    font-family: Instrument Sans;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 650;
                    line-height: 120%;
                }

                .confirmed-events-wrapper {
                    max-height: 745px;
                    overflow: hidden;
                }
                .event-cards-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    max-width: 727px;

                    .event-time,
                    .cover-charge,
                    .event-age {
                        color: #acacac !important;
                        font-family: Instrument Sans !important;
                        font-size: 14px !important;
                        font-style: normal !important;
                        font-weight: 500 !important;
                        line-height: 130% !important;
                        letter-spacing: 0.14px !important;
                    }

                    .title-extra {
                        margin-bottom: 0px !important;
                        color: #acacac !important;
                        font-family: Instrument Sans !important;
                        font-size: 16px !important;
                        font-style: normal !important;
                        font-weight: 650 !important;
                        line-height: 125% !important;
                    }

                    .keyword-vibes {
                        margin-top: 6px;

                        .vibe {
                            color: #acacac;
                            font-family: Instrument Sans;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 130%;
                            letter-spacing: 0.14px;
                        }
                    }

                    .featured-artists-wrapper {
                        margin-top: 22px;
                        min-height: 40px;
                        display: flex;
                        flex-direction: row;
                        gap: 8px;
                        justify-content: flex-start;
                        align-items: center;

                        .featured-label {
                            color: #acacac;
                            font-family: Instrument Sans;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 500;
                            line-height: 130%;
                            letter-spacing: 0.14px;
                            margin-bottom: 0px;
                        }

                        .featured-artist {
                            display: flex;
                            flex-direction: row;
                            gap: 10px;
                            align-items: center;
                            padding: 5px 12px 5px 5px;
                            border-radius: 100px;
                            border: 1px solid #acacac;
                            background: #262626;

                            img {
                                border-radius: 50%;
                                width: 28px;
                                height: 28px;
                                object-fit: cover;
                            }

                            p {
                                margin-bottom: 0px;
                                color: #acacac;
                                font-family: Instrument Sans;
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 500;
                                line-height: 130%;
                                letter-spacing: 0.14px;
                            }
                        }
                    }

                    .event-action-btns {
                        display: flex;
                        flex-direction: row;
                        gap: 8px;

                        .make-offer-btn,
                        .add-to-cal-btn,
                        .share-btn {
                            padding: 7px 30px 9px 30px;
                            border-radius: 100px;
                            min-width: 163px;
                            text-wrap: nowrap;
                        }

                        .make-offer-btn,
                        .add-to-cal-btn {
                            border: none;
                            background: #ba87ff;
                            color: black;
                            font-family: Instrument Sans;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 650;
                            line-height: 125%;
                            min-width: 180px;
                        }

                        .share-btn {
                            border: 1px solid #ba87ff;
                            background: #262626;
                            color: #ba87ff;
                            font-family: Instrument Sans;
                            font-size: 16px;
                            font-style: normal;
                            font-weight: 650;
                            line-height: 125%;
                        }
                    }
                }
            }

            .media-wrapper {
                display: flex;
                flex-direction: column;
                gap: 60px;
                z-index: 11;
                overflow: hidden;
                width: 100%;

                .media-carousel-wrapper {
                    display: flex;
                    justify-content: flex-start;
                    margin-bottom: 160px;
                }
            }
        }
    }
</style>
